import type { DraftExperimentFormProps, Experiment } from '@gonfalon/experiments/types';
import { useDeleteStratifiedSampling } from '@gonfalon/rest-api/queries/experiments';

type UpdateCovariateForDraftExperimentProps = {
  projectKey: string;
  environmentKey: string;
  experimentKey: string;
  experiment?: Experiment;
};

export const useUpdateStratifiedSamplingForDraftExperiment = (props: UpdateCovariateForDraftExperimentProps) => {
  const { projectKey, environmentKey, experimentKey } = props;
  const { mutateAsync: deleteStratifiedSampling } = useDeleteStratifiedSampling();
  const updateStratifiedSamplingAfterIteration = async (
    updatedValues: DraftExperimentFormProps,
    defaultValues: DraftExperimentFormProps,
  ) => {
    const previousStratifiedSamplingId = defaultValues.iterationProps?.covariateInfo?.id;
    const deletedCovariateId = updatedValues.iterationProps?.deletedCovariateId;
    const shouldCallDelete = !!deletedCovariateId && deletedCovariateId === previousStratifiedSamplingId;
    if (shouldCallDelete) {
      return await deleteStratifiedSampling({
        covariateId: previousStratifiedSamplingId,
        environmentKey,
        experimentKey,
        projectKey,
        header: { 'LD-API-Version': 'beta' },
      });
    }
  };

  return { updateStratifiedSamplingAfterIteration };
};
